import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment, { Moment } from 'moment';

interface ReportDateRangeProps {
    onChange: (start: Moment, end: Moment) => void;
    // Límite hacia atrás en el calendario (ej. moment().subtract(1, 'year')); sin límite si no se indica
    minDate?: Moment;
    // Duración máxima del rango (ej. { months: 1 }); sin límite si no se indica
    maxSpan?: moment.DurationInputObject;
}

// Selector de rango de fechas estándar para los reportes (inicia en hoy)
const ReportDateRange = ({ onChange, minDate, maxSpan }: ReportDateRangeProps) => (
    <div className="input-group">
        <span className="input-group-text bg-white"><i className="bi bi-calendar3" /></span>
        <DateRangePicker
            onCallback={onChange}
            initialSettings={{
                locale: {
                    format: 'DD/MM/YYYY',
                    cancelLabel: 'Cancelar',
                    applyLabel: 'Aplicar',
                    customRangeLabel: 'Seleccionar fechas',
                },
                startDate: moment(),
                endDate: moment(),
                minDate,
                maxDate: moment(),
                maxSpan,
                ranges: {
                    'Hoy': [moment(), moment()],
                    'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Esta semana': [moment().startOf('week'), moment()],
                    'Este mes': [moment().startOf('month'), moment()],
                    'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                    'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                },
            }}
        >
            <input type="text" className="form-control" readOnly style={{ backgroundColor: 'white' }} />
        </DateRangePicker>
    </div>
);

export default ReportDateRange;
